import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MessageCircle, MapPin } from "lucide-react";
import { useSettings } from "../context/SettingsContext";
import { openOnboarding } from "./OnboardingPopup";
import { LOGO_URL } from "../lib/api";

export const Footer = () => {
  const biz = useSettings().business || {};
  const wa = biz.whatsapp || "";
  const ig = biz.instagram || "";
  return (
  <footer data-testid="site-footer" className="bg-[var(--ha-maroon)] text-[var(--ha-cream)] mt-32">
    <div className="max-w-7xl mx-auto px-6 sm:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <div className="flex items-center gap-3 mb-6">
          <img src={biz.logo_url || LOGO_URL} alt={biz.brand_name} onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = LOGO_URL; }} className="h-14 w-14 object-contain bg-[var(--ha-cream)] p-1" />
          <p className="font-serif-display text-3xl tracking-[0.2em] text-[var(--ha-cream)]">{biz.brand_name || "HYPPE AROMA"}</p>
        </div>
        <p className="font-serif-display italic text-xl text-[var(--ha-gold)] mb-6">{biz.tagline || "Enhance Your Natural Aura"}.</p>
        <p className="text-sm text-[var(--ha-cream)]/70 leading-relaxed max-w-md">
          {biz.footer_blurb || "Premium 25% EDP fragrances · Hand-blended in India · Designer inspirations & custom compositions."}
        </p>
      </div>

      <div className="md:col-span-3">
        <p className="font-mono-label text-[10px] uppercase tracking-[0.25em] text-[var(--ha-gold)] mb-5">Explore</p>
        <ul className="space-y-3 text-sm">
          {[
            ["/", "Atelier"], ["/shop", "Shop"], ["/#alchemist", "Mixology"], ["/journal", "Journal"],
            ["/about", "Our Story"], ["#howitworks", "How It Works", "action"],
            ["/faq", "FAQ"], ["/policies", "Shipping & Returns"],
            ["/admin", "Laboratory"],
          ].map(([to, label, action]) => (
            <li key={to}>
              {action
                ? <button type="button" data-testid="footer-howitworks" onClick={openOnboarding} className="hover:text-[var(--ha-gold)] transition-colors text-left">{label}</button>
                : <Link to={to} className="hover:text-[var(--ha-gold)] transition-colors">{label}</Link>}
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-4">
        <p className="font-mono-label text-[10px] uppercase tracking-[0.25em] text-[var(--ha-gold)] mb-5">Contact</p>
        <ul className="space-y-3 text-sm">
          <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-0.5 text-[var(--ha-gold)]" /><a href={`mailto:${biz.email}`} className="hover:text-[var(--ha-gold)]">{biz.email}</a></li>
          <li className="flex items-start gap-3"><Phone className="w-4 h-4 mt-0.5 text-[var(--ha-gold)]" /><a href={`tel:${(biz.phone||"").replace(/\s/g,"")}`} className="hover:text-[var(--ha-gold)]">{biz.phone}</a></li>
          <li className="flex items-start gap-3"><MessageCircle className="w-4 h-4 mt-0.5 text-[var(--ha-gold)]" /><a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" className="hover:text-[var(--ha-gold)]">WhatsApp</a></li>
          <li className="flex items-start gap-3"><Instagram className="w-4 h-4 mt-0.5 text-[var(--ha-gold)]" /><a href={`https://instagram.com/${ig}`} target="_blank" rel="noreferrer" className="hover:text-[var(--ha-gold)]">@{ig}</a></li>
          <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5 text-[var(--ha-gold)] shrink-0" /><span className="text-[var(--ha-cream)]/75">{(biz.address_lines || []).map((l) => <span key={l}>{l}<br/></span>)}</span></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-[var(--ha-cream)]/15">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-6 flex flex-col sm:flex-row gap-3 justify-between text-[10px] font-mono-label uppercase tracking-[0.18em] text-[var(--ha-cream)]/50">
        <span>© {biz.established || "2026"} {biz.brand_name || "HYPPE AROMA"} · Founded by {biz.founder || "Kruparth Pathak"}</span>
        <span>{biz.footer_note || "Hand-blended in Ahmedabad · 25% EDP"}</span>
      </div>
    </div>
  </footer>
  );
};
